import { Label, makeStyles, tokens } from '@fluentui/react-components';
import { Warning20Filled } from '@fluentui/react-icons';

export interface IWarningLabelProps {
    warningMessage: string;
    labelClassName?: string;
    iconTestId?: string;
    role?: string;
}

const useStyles = makeStyles({
    warningMessageContainerStyles: {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        gap: '10px',
    },
    warningIcon: {
        border: 'none',
        backgroundColor: 'inherit',
        alignSelf: 'center',
        color: tokens.colorStatusWarningForeground1,
        minWidth: '20px',
    },
});

const WarningLabel: React.FC<IWarningLabelProps> = ({ warningMessage, labelClassName, iconTestId, role }) => {
    const { warningMessageContainerStyles, warningIcon } = useStyles();

    return (
        <div className={warningMessageContainerStyles} tabIndex={0} aria-label={warningMessage} role={role}>
            <Warning20Filled tabIndex={-1} aria-hidden='false' className={warningIcon} data-testid={iconTestId} />
            <Label className={labelClassName}>{warningMessage}</Label>
        </div>
    );
};

export default WarningLabel;
